export enum CctvAccessRulesKeyEnum {
  // --- Модуль CCTV (Системы видеонаблюдения) ---

  // --- Раздел CCTV.SECTIONS.PARKING (Парковка) ---
  CCTV_PARKING_SETTINGS_READ = 'CCTV_PARKING_SETTINGS_READ',
  CCTV_PARKING_SETTINGS_WRITE = 'CCTV_PARKING_SETTINGS_WRITE',
  CCTV_PARKING_CAR_CATEGORY_READ = 'CCTV_PARKING_CAR_CATEGORY_READ',
  CCTV_PARKING_CAR_CATEGORY_WRITE = 'CCTV_PARKING_CAR_CATEGORY_WRITE',
  CCTV_PARKING_TRANSIT_TASK_READ = 'CCTV_PARKING_TRANSIT_TASK_READ',
  CCTV_PARKING_TRANSIT_TASK_WRITE = 'CCTV_PARKING_TRANSIT_TASK_WRITE',
  CCTV_PARKING_RESIDENT_CAR_READ = 'CCTV_PARKING_RESIDENT_CAR_READ',
  CCTV_PARKING_RESIDENT_CAR_WRITE = 'CCTV_PARKING_RESIDENT_CAR_WRITE',
  CCTV_PARKING_HIKVISION_CAMERA_READ = 'CCTV_PARKING_HIKVISION_CAMERA_READ',
  CCTV_PARKING_HIKVISION_CAMERA_WRITE = 'CCTV_PARKING_HIKVISION_CAMERA_WRITE',
  CCTV_PARKING_REPORTS_READ = 'CCTV_PARKING_REPORTS_READ',
  CCTV_PARKING_REPORTS_WRITE = 'CCTV_PARKING_REPORTS_WRITE',

  // Разрешения (Парковка)
  CCTV_PARKING_CAN_BLOCK_PARKING = 'CCTV_PARKING_CAN_BLOCK_PARKING',
  CCTV_PARKING_CAN_DELETE_ACTIVE_TRANSIT_TASK = 'CCTV_PARKING_CAN_DELETE_ACTIVE_TRANSIT_TASK',
  CCTV_PARKING_CAN_UNLINK_TRANSIT_TASK_EVENT = 'CCTV_PARKING_CAN_UNLINK_TRANSIT_TASK_EVENT',
  CCTV_PARKING_ACCESS_TO_ALL_TRANSIT_TASK = 'CCTV_PARKING_ACCESS_TO_ALL_TRANSIT_TASK',
  CCTV_PARKING_MANUAL_OPEN = 'CCTV_PARKING_MANUAL_OPEN',
  CCTV_PARKING_EDIT_EVENT = 'CCTV_PARKING_EDIT_EVENT'
}
